// demoFrames.js – full script with corrected IDs & pacing tweaks
export const demoFrames = [
    /* 1 ───────────── Assistant hook ───────────── */
    {
        message: {
            id: "demo-01",
            senderType: "assistant",
            targetLanguageMessage: { status: "done", value: "Welcome to Palyglot!" },
        },
    },
    {
        message: {
            id: "demo-02",
            senderType: "assistant",
            targetLanguageMessage: {
                status: "done",
                value: "What language would you like to learn?",
            },
        },
    },

    /* 2 ───────────── User chooses language ───────────── */
    {
        message: {
            id: "demo-03",
            senderType: "user",
            targetLanguageMessage: {
                status: "done",
                value: "I'm trying to learn Japanese.",
            },
        },
    },

    /* 3 ───────────── Language set notice (EN→JP) ───────────── */
    {
        message: {
            id: "demo-04",
            senderType: "assistant",
            originalMessage: {
                status: "loaded",
                value: "Your language has been set to Japanese!",
            },
            targetLanguageMessage: {
                status: "done",
                value: "あなたの言語設定は日本語になりました！",
            },
        },
        delay: 4000, // ↑ first TL line – linger so users can read
    },

    /* 4 ───────────── Intro copy (no morphemes yet) ───────────── */
    {
        message: {
            id: "demo-05",
            senderType: "assistant",
            originalMessage: {
                status: "loaded",
                value: "You can learn languages through conversation…",
            },
            targetLanguageMessage: {
                status: "done",
                value: "会話を通して言語を学べます…",
            },
        },
    },

    /* 5 ───────────── Assisted-immersion tagline WITH morphemes ───────────── */
    {
        message: {
            id: "demo-06",
            senderType: "assistant",
            originalMessage: {
                status: "loaded",
                value: "…with assisted immersion!",
            },
            targetLanguageMessage: {
                status: "done",
                value: "…補助的なイマージョンで学びます！",
            },
            morphemeTranslationDetails: {
                status: "loaded",
                value: [
                    ["…", "…", "…"],
                    ["補助的", "hojoteki", "auxiliary"],
                    ["な", "na", "(adj.)"],
                    ["イマージョン", "imājyon", "immersion"],
                    ["で", "de", "by/with"],
                    ["学びます", "manabimasu", "learn"],
                    ["！", "！", "!"],
                ],
            },
        },
        skipFirstMorphPad: true,
        delay: 5500, // ↑ first morpheme table – extra scanning time
    },

    /* 6 ───────────── Fade-away notice (もっと×3) ───────────── */
    {
        message: {
            id: "demo-07",
            senderType: "assistant",
            originalMessage: {
                status: "loaded",
                value: "The translations will fade away as you use the word more and more and more!",
            },
            targetLanguageMessage: {
                status: "done",
                value: "その単語をもっともっともっと使うにつれて、翻訳は薄れていきます！",
            },
            morphemeTranslationDetails: {
                status: "loaded",
                value: [
                    ["その", "sono", "that"],
                    ["単語", "tango", "word"],
                    ["を", "o", "(obj.)"],
                    ["もっと", "motto", "more"],
                    ["もっと", "motto", "more"],
                    ["もっと", "motto", "more"],
                    ["使う", "tsukau", "use"],
                    ["につれて", "ni tsurete", "as"],
                    ["翻訳", "honyaku", "translations"],
                    ["は", "wa", "(topic)"],
                    ["薄れて", "usurete", "fade (and)"],
                    ["いきます", "ikimasu", "go"],
                    ["！", "！", "!"],
                ],
            },
        },
        /* ↓ NEW: pacing now lives on the morpheme table */
        customMorphChunks: [
            ["その", "sono", "that"],
            ["単語", "tango", "word"],
            ["を", "o", "(obj.)"],
            ["もっと", "motto", "more"],
            ["もっと", "motto", "more"],
            ["もっと", "motto", "more"],
            ["使う", "tsukau", "use"],
            ["につれて", "ni tsurete", "as"],
            ["翻訳", "honyaku", "translations"],
            ["は", "wa", "(topic)"],
            ["薄れて", "usurete", "fade (and)"],
            ["いきます", "ikimasu", "go"],
            ["！", "！", "!"],
        ],
        morphChunkDelayOverride: 800,
        delay: 6000,
    },

    /* 7 ───────────── Correct / translation showcase ───────────── */
    {
        message: {
            id: "demo-08",
            senderType: "assistant",
            originalMessage: { status: "loaded", value: "You can respond in English!" },
            targetLanguageMessage: {
                status: "done",
                value: "英語で返答しても大丈夫ですよ！",
            },
            morphemeTranslationDetails: {
                status: "loaded",
                value: [
                    ["英語", "eigo", "English"],
                    ["で", "de", "in"],
                    ["返答しても", "hentō shite mo", "respond even if"],
                    ["大丈夫", "daijōbu", "fine"],
                    ["です", "desu", "is"],
                    ["よ", "yo", "(emphasis)"],
                    ["！", "！", "!"],
                ],
            },
        },
    },
    {
        message: {
            id: "demo-09",
            senderType: "user",
            originalMessage: { status: "loaded", value: "Like this?" },
            targetLanguageMessage: { status: "done", value: "こんな感じですか？" },
            morphemeTranslationDetails: {
                status: "loaded",
                value: [
                    ["こんな", "konna", "like this"],
                    ["感じ", "kanji", "feeling"],
                    ["です", "desu", "is"],
                    ["か", "ka", "(q.)"],
                    ["？", "？", "?"],
                ],
            },
        },
        typingDelay: 60, // slower plain-English typing
    },
    {
        message: {
            id: "demo-10",
            senderType: "assistant",
            originalMessage: { status: "loaded", value: "Or your target language." },
            targetLanguageMessage: {
                status: "done",
                value: "または、目標言語でも大丈夫ですよ。",
            },
            morphemeTranslationDetails: {
                status: "loaded",
                value: [
                    ["または", "matawa", "or"],
                    ["目標", "mokuhyō", "goal"],
                    ["言語", "gengo", "language"],
                    ["でも", "demo", "even"],
                    ["大丈夫", "daijōbu", "fine"],
                    ["です", "desu", "is"],
                    ["よ", "yo", "(emphasis)"],
                    ["。", "。", "。"],
                ],
            },
        },
    },
    {
        message: {
            id: "demo-11",
            senderType: "user",
            originalMessage: { status: "loaded", value: "Honto?" },
            targetLanguageMessage: { status: "done", value: "本当？" },
            morphemeTranslationDetails: {
                status: "loaded",
                value: [
                    ["本当", "hontō", "really"],
                    ["？", "？", "?"],
                ],
            },
        },
        typingDelay: 60, // slower plain-JP typing
    },
    {
        message: {
            id: "demo-12",
            senderType: "assistant",
            originalMessage: { status: "loaded", value: "Or any mix of languages!" },
            targetLanguageMessage: {
                status: "done",
                value: "もしくは言語を混ぜても大丈夫です！",
            },
            morphemeTranslationDetails: {
                status: "loaded",
                value: [
                    ["もしくは", "moshikuwa", "or"],
                    ["言語", "gengo", "language"],
                    ["を", "o", "(obj.)"],
                    ["混ぜて", "mazete", "mix (and)"],
                    ["も", "mo", "even"],
                    ["大丈夫", "daijōbu", "fine"],
                    ["です", "desu", "is"],
                    ["！", "！", "!"],
                ],
            },
        },
    },
    {
        message: {
            id: "demo-13",
            senderType: "user",
            originalMessage: {
                status: "loaded",
                value: "Sore wa really かっこいい!",
            },
            targetLanguageMessage: { status: "done", value: "それは本当にかっこいい！" },
            morphemeTranslationDetails: {
                status: "loaded",
                value: [
                    ["それ", "sore", "that"],
                    ["は", "wa", "(topic)"],
                    ["本当に", "hontōni", "really"],
                    ["かっこいい", "kakkoii", "cool"],
                    ["！", "！", "!"],
                ],
            },
        },
        typingDelay: 70, // slowest – highlights script switches
    },

    /* 8 ───────────── Wrap-up prompts ───────────── */
    {
        message: {
            id: "demo-14",
            senderType: "assistant",
            originalMessage: { status: "loaded", value: "Ready to dive in?" },
            targetLanguageMessage: { status: "done", value: "始める準備はできましたか？" },
            morphemeTranslationDetails: {
                status: "loaded",
                value: [
                    ["始める", "hajimeru", "to start"],
                    ["準備", "junbi", "preparation"],
                    ["は", "wa", "(topic)"],
                    ["できました", "dekimashita", "have done/ready"],
                    ["か", "ka", "(q.)"],
                    ["？", "？", "?"],
                ],
            },
        },
    },
    {
        message: {
            id: "demo-15",
            senderType: "assistant",
            originalMessage: { status: "loaded", value: "Let's begin!" },
            targetLanguageMessage: { status: "done", value: "始めましょう！" },
            morphemeTranslationDetails: {
                status: "loaded",
                value: [
                    ["始めましょう", "hajimemashō", "let's start"],
                    ["！", "！", "!"],
                ],
            },
        },
    },
    {
        message: {
            id: "demo-16",
            senderType: "assistant",
            originalMessage: { status: "loaded", value: "How was your day?" },
            targetLanguageMessage: { status: "done", value: "今日はどんな一日でしたか？" },
            morphemeTranslationDetails: {
                status: "loaded",
                value: [
                    ["今日", "kyō", "today"],
                    ["は", "wa", "(topic)"],
                    ["どんな", "donna", "what kind of"],
                    ["一日", "ichinichi", "day"],
                    ["でした", "deshita", "was"],
                    ["か", "ka", "(q.)"],
                    ["？", "？", "?"],
                ],
            },
        },
    },
];
